import Image from "next/image";
import type { ContentStatus } from "@prisma/client";
import { getImageUrl } from "@/libs/CloudFlare";
import capitalize from "@/utils/capitalize";
import { cn } from "@/lib/utils";

interface IProps {
  text?: "black" | "white";
  contentByLangs?: {
    id: string;
    title: string | null;
    desc?: string | null;
    bannerImg: string | null;
    thumbnail: string | null;
    createAt: Date;
    updateAt: Date;
    status: ContentStatus;
    language: {
      id: string;
      name: string;
    };
    tags: {
      Tag: {
        name: string | null;
        id: string | null;
      };
    }[];
  }[];
  thumbnail?: string | null;
  title?: string | null;
  desc: string | null;
  href?: string;
  continent: string | null;
  isLoading?: boolean;
  variant?: "light" | "neural";
}

function Card(props: IProps) {
  if (props.isLoading) {
    return (
      <div className="flex flex-col items-start overflow-hidden w-full relative bg-[#E7E7E7] rounded-[32px] animate-pulse">
        <div className="w-full !aspect-[16/10] bg-[#D1D1D1] rounded-[28px] px-[24px] py-[12px]">
          <div className="h-5 bg-[#E7E7E7] rounded-full w-1/4"></div>
        </div>
        <div className="py-[16px] px-[24px] space-y-[10px] w-full">
          <div className="h-5 bg-[#D1D1D1] rounded w-3/4"></div>
          <div className="h-4 bg-[#D1D1D1] rounded w-full"></div>
        </div>
      </div>
    );
  }

  return (
    <div className={cn(
      "flex flex-col items-start overflow-hidden w-full relative bg-[#F6F6F6] rounded-[32px]  h-full",
      props.variant === "light" ? "bg-white" : "bg-[#F6F6F6]"
    )}>
      {
        !!props.continent && (
          <div className=" absolute top-3 left-4 bg-white text-black rounded-full my-[4px] px-[8px]">
            {capitalize(props.continent.toLocaleLowerCase())}
          </div>
        )
      }
      <a
        href={props.href ?? "/airport-transfer/" + props.contentByLangs?.[0]?.id}
        className="!no-underline w-full"
      >
        {props?.contentByLangs?.[0]?.thumbnail ? (
          <Image
            alt={props.title ?? ""}
            src={getImageUrl(props?.contentByLangs[0]?.thumbnail ?? "")}
            width={400}
            height={400}
            className=" w-full object-cover !aspect-[16/10] rounded-[28px]"
          />
        ) : props.thumbnail ? (
          <Image
            alt={props.title ?? ""}
            src={getImageUrl(props?.thumbnail ?? "")}
            width={400}
            height={400}
            className=" w-full object-cover !aspect-[16/10] rounded-[28px]"
          />
        ) : (<div
          className=" w-full object-cover !aspect-[16/10] bg-[#D9D9D9] rounded-[28px]"
        />)}
        <div className="py-[16px] px-[24px] space-y-[10px]">
          <p className=" font-[600] text-[18px] ">{props.title ?? ""}</p>
          <span className=" font-[400] text-[14px] text-[#6F6F6F] line-clamp-3">{props.desc}</span>
        </div>
      </a>
    </div>
  );
}

export default Card;

